import { useState } from "react";

import { useRouter } from "next/router";

import PropTypes from "prop-types";

import ButtonNew from "components/atoms/ButtonNew/index";
import Dropdown from "components/atoms/Dropdown";

const checkLocale = (path) => {
  return path.includes("/offshore")
    ? path.split("/offshore")[1]
    : path.includes("/hk")
    ? path.split("/hk")[1]
    : path.includes("/sg")
    ? path.split("/sg")[1]
    : path.includes("/vn") && path.split("/vn")[1];
};
const Component = ({ data }) => {
  const router = useRouter();
  const [activeIndex] = useState(checkLocale(router.pathname));

  return (
    <>
      <div className="shadow-bbc relative  hidden w-fit rounded-xl bg-white text-center lg:inline-block">
        <ul className="whitespace-nowrap py-3 px-5">
          {Array.isArray(data) &&
            data.map((item, index) => {
              return (
                <li
                  key={index}
                  className={`inline-block  ${
                    index < data.length - 1 ? "border-r-2" : ""
                  }`}
                >
                  <ButtonNew
                    as="a"
                    variant={"ghost"}
                    href={item.uri}
                    useRouter
                    btnTextColor={`${
                      activeIndex === item.uri
                        ? ""
                        : "text-bbc-neutral-700 hover:text-bbc-brand-600"
                    }`}
                    othersClass={`${
                      activeIndex === item.uri ? "" : "inline-block font-normal"
                    }`}
                  >
                    {item.title}
                  </ButtonNew>
                </li>
              );
            })}
        </ul>
      </div>
      <Dropdown
        className="dropdown-default m-auto block lg:hidden"
        data={data}
        activeIndex={
          data.length > 0 && data.find((item) => activeIndex === item.uri).title
        }
      />
    </>
  );
};

export default Component;

Component.propTypes = {
  data: PropTypes.array,
  children: PropTypes.element,
};

Component.defaultProps = {
  data: [],
  children: <></>,
};
